export default function limitValue(value, min, max) {
    return Math.max(Math.min(value, max), min);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/util/limit-value.js
// module id = 646
// module chunks = 0